export default __webpack_public_path__ + "static/media/img_restmon-colorBkg.7edf6718.png";